export interface Viewport { scale: number; tx: number; ty: number }

export function fitViewport(imgW: number, imgH: number, canvasW: number, canvasH: number, margin = 24): Viewport {
  const scale = Math.min((canvasW - 2 * margin) / imgW, (canvasH - 2 * margin) / imgH);
  return { scale, tx: (canvasW - imgW * scale) / 2, ty: (canvasH - imgH * scale) / 2 };
}

export function zoomAt(v: Viewport, factor: number, cx: number, cy: number, min = 0.05, max = 32): Viewport {
  const scale = Math.min(max, Math.max(min, v.scale * factor));
  const k = scale / v.scale;
  return { scale, tx: cx - (cx - v.tx) * k, ty: cy - (cy - v.ty) * k };
}

export function pan(v: Viewport, dx: number, dy: number): Viewport { return { ...v, tx: v.tx + dx, ty: v.ty + dy }; }

export function toImage(v: Viewport, cx: number, cy: number) { return { x: (cx - v.tx) / v.scale, y: (cy - v.ty) / v.scale }; }
